import { useState, useCallback } from "react";

/**
 * Backdrop-safe modal close.
 * Only closes the modal if BOTH mousedown AND mouseup happen on the backdrop.
 * Prevents accidental closes when the user drags to select text inside inputs
 * and their cursor briefly exits the modal container.
 *
 * Usage:
 *   const backdrop = useBackdropClose(onClose);
 *   <div {...backdrop.backdropProps} className="fixed inset-0 …">
 *     <div {...backdrop.contentProps}>modal content</div>
 *   </div>
 */
export function useBackdropClose(onClose) {
    const [down, setDown] = useState(false);
    const onMouseDown = useCallback((e) => {
        if (e.target === e.currentTarget) setDown(true);
    }, []);
    const onMouseUp = useCallback((e) => {
        if (down && e.target === e.currentTarget) onClose();
        setDown(false);
    }, [down, onClose]);
    return {
        backdropProps: { onMouseDown, onMouseUp },
        contentProps: {
            onMouseDown: (e) => e.stopPropagation(),
            onMouseUp: (e) => e.stopPropagation(),
        },
    };
}
